import { Injectable } from '@angular/core';
import { AccessService } from '../access.service';
import { FeatureFlagService } from '../feature-flag/feature-flag.service';
import { PermissionService } from '../permissions/permission.service';
import { MORE_TAB, NAV_ITEMS } from './navigation.config';
import { NavItem, NavItems, NavRoute } from './navigation.interface';
import { firstValueFrom } from 'rxjs';

const TOTAL_THUMB_NAV_TABS = 4; // not including More tab

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  navItems!: NavItems;

  constructor(
    private _featureFlagService: FeatureFlagService,
    private _permissionService: PermissionService,
    private _accessService: AccessService,
  ) {}

  async initialize(): Promise<void> {
    const navItems = NAV_ITEMS.filter((navItem) => {
      if (navItem.featureFlag) {
        return (
          this._featureFlagService.isFeatureOn(navItem.featureFlag) &&
          this._permissionService.doesUserHavePermission(navItem.permission!)
        );
      } else {
        return this._permissionService.doesUserHavePermission(
          navItem.permission!,
        );
      }
    });
    const filteredNavItems: NavItem[] = [];
    for (const navItem of navItems) {
      if (typeof navItem.access === 'string') {
        const hasAccess = await firstValueFrom(
          this._accessService[navItem.access],
        );

        if (hasAccess) {
          filteredNavItems.push(navItem);
        }
      } else {
        filteredNavItems.push(navItem);
      }
    }
    this.navItems = filteredNavItems;
  }

  get thumbNav(): NavItems {
    const tabs = this.navItems.slice(0, TOTAL_THUMB_NAV_TABS);
    tabs.push(MORE_TAB);
    return tabs;
  }

  get moreMenu(): NavItems {
    return this.navItems.slice(TOTAL_THUMB_NAV_TABS);
  }

  get moreRoutes(): string[] {
    const navRoutes = this.moreMenu.filter(
      (menuItem) => menuItem.type === 'route',
    ) as NavRoute[];
    const routes = navRoutes.map((navRoute) => navRoute.route);
    return ['more', ...routes];
  }
}
